const getToken = function() {
  let token = window.location.search
  if (token.includes('?token=')) {
    token = token.split('?token=')
    if (token.length === 2) {
      return token[1]
    }
  }
  return ''
}

function timeoutFunction(ms, promise) {
  return new Promise(function(resolve, reject) {
    setTimeout(function() {
      reject(new Error('timeout'))
    }, ms)
    promise.then(resolve, reject)
  })
}

export default function(path, timeOut = null, isJson = true, signal = null) {
  const token = getToken()
  return args => {
    const headers = new Headers()
    headers.set('Accept', 'application/json')
    if (isJson) headers.set('Content-Type', 'application/json')
    if (token) headers.set('x-esptkn', token)
    let body = JSON.stringify(args)
    if (!isJson) {
      body = new FormData()
      Object.entries(args).forEach(([k, v]) => {
        body.append(k, v)
      })
    }
    let serverUrl =
      process.env.NODE_ENV === 'production' ? '' : 'http://localhost'
    if (timeOut)
      return timeoutFunction(
        timeOut,
        fetch(`${serverUrl}/${path}`, {
          method: 'POST',
          headers,
          body,
          signal,
        }),
      )
    return fetch(`${serverUrl}/${path}`, {
      method: 'POST',
      headers,
      body,
      signal,
    })
  }
}
